import React, { FC, KeyboardEvent, RefObject } from 'react'
import { Swiper } from 'swiper'

import { Carat, RotateClockwise } from '@syconium/little-miss-figgy'

import { useTranslation } from '../../../../app/_providers/TranslationProvider.client'
import { trackEvent } from '../../../../lib/analytics'
import { LeftArrow, NavigationArrowsWrapper, RightArrow } from '../ReviewsSwiperMediaSlider.styles'

interface NavLeftRight {
  gallerySwiperRef: RefObject<Swiper | undefined>
}

export const NavigationArrows: FC<NavLeftRight> = ({ gallerySwiperRef }) => {
  const {
    pages: {
      product: { gallery: strings },
    },
  } = useTranslation()

  const handlePrevClick = () => {
    gallerySwiperRef.current?.slidePrev()
  }

  const handleNextClick = () => {
    gallerySwiperRef.current?.slideNext()
  }

  const handlePrevKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ' || event.key === 'ArrowLeft') {
      event.preventDefault()
      handlePrevClick()
    }
  }

  const handleNextKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ' || event.key === 'ArrowRight') {
      event.preventDefault()
      handleNextClick()
    }
  }

  return (
    <NavigationArrowsWrapper>
      <LeftArrow
        role='button'
        tabIndex={0}
        aria-label={strings.previousImage}
        onClick={handlePrevClick}
        onKeyDown={(event: KeyboardEvent) => handlePrevKeyDown(event)}
        {...trackEvent({ category: 'reviews modal', action: 'view previous image' })}
      >
        <Carat height='18' rotateClockwise={RotateClockwise.Half} width='16' />
      </LeftArrow>
      <RightArrow
        role='button'
        tabIndex={0}
        aria-label={strings.nextImage}
        onClick={handleNextClick}
        onKeyDown={(event: KeyboardEvent) => handleNextKeyDown(event)}
        {...trackEvent({ category: 'reviews modal', action: 'view next image' })}
      >
        <Carat height='18' width='16' />
      </RightArrow>
    </NavigationArrowsWrapper>
  )
}
